module.exports = {
      id: "app-store-mini-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "static/sprite-0THSJOHOZrRZCeJP5U2eK.svg#app-store-mini-usage",
      toString: function () {
        return this.url;
      }
    }